import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Button from '../components/common/Button';

const NotFound = () => {
  return (
    <div className="page-wrapper bg-gray-50">
      <Navbar />
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-display font-xbold text-9xl text-primary mb-4 animate-float">404</h1>
        <h2 className="heading-2 mb-4">Page not found</h2>
        <p className="subheading max-w-md mb-8">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button size="lg" variant="primary">Return Home</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
